import { createAxiosInstance } from '@speechki-frontend/shared/axios';

const URL = process.env.VUE_APP_BASE_URL;
const axios = createAxiosInstance(URL, { enableGuestAccess: true, rejectOn5xx: true });

export const fetchPersonages = async (params = {}) => {
    return axios.get('/api/v1/personages/', { params });
};

export const createPersonage = data => {
    return axios.post('/api/v1/personages/', data);
};

export const updatePersonage = (id, data) => {
    return axios.patch(`/api/v1/personages/${id}`, data);
};

export const deletePersonage = id => {
    return axios.delete(`/api/v1/personages/${id}`);
};
